import React, { useEffect, useState } from "react"
import DocumentMeta from "react-document-meta"
import Form from "../components/Forms/Form"
import Sogehts from "../components/home/Sogehts"
import Header from "../components/Header"
import Hero from "../components/home/Hero"
import Info from "../components/Info"
import Footer from "../components/Footer"
import RefundCounter from "../components/RecoundCounter"
import { getPromoLimit, getWeeklyLimit } from "../env"
import { useNavigate } from "react-router-dom"
import Rezepte from "../components/home/Rezepte"

const Home: React.FC = () => {
	// SEO Meta Tags
	const [limitReached, setLimitReached] = useState<boolean>(false)
	const [isApiError, setApiError] = useState<boolean>(false)
	const navigate = useNavigate()

	const meta = {
		title: "Alpro Gratis Testen",
		description:
			"alpro gratis testen, Danone, alpro, pflanzlich, pflanzliche joghurtalternative, Gratis-Testen-Aktion, gratis, testen, kostenlos, cashback, Joghurt, Frühstück, vegan",
		meta: {
			name: {
				robots: "noindex, nofollow",
			},
		},
	}
	async function getOrderLimits() {
		let maxLimit = await getWeeklyLimit()
		if (maxLimit < 1) {
			setApiError(true)
			navigate("/weeklyover")
		}
	}

	useEffect(() => {
		getOrderLimits()
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])
	return (
		<DocumentMeta {...meta}>
			<div className="bg-white">
				<Header />
				<Hero />
				<Sogehts />
				<RefundCounter />
				<Form />
				<Rezepte />
				<Footer />
			</div>
		</DocumentMeta>
	)
}
export default Home
